import { Component, OnInit, Output, Input, EventEmitter, ViewChild, ElementRef, Injector, ApplicationRef, ComponentFactoryResolver, SimpleChanges } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwCheckAttachmentBoxComponent } from './sw-check-attachment-box/sw-check-attachment-box.component';
declare var $: any;

/**
 * 创建人：袁俊双
 * 
 * 时间：2019-6-01
 * 
 * 描述：查看附件
 * 
 * 使用说明: 参考 sw-check-attachment 配置应用说明文档
 * 
 * 更新记录: 
 * 
 * 1.查看附件 by yuanjs
 */
@Component({
  selector: 'sw-check-attachment',
  templateUrl: './sw-check-attachment.component.html',
  styleUrls: ['./sw-check-attachment.component.css']
})
export class SwCheckAttachmentComponent implements OnInit {


  /**
   * 业务表id(必传)
   * 
   * 查看附件回显方法: 通过上传策略和业务表id查询文件信息
   */
  @Input() businessId: string;

  /**
   * 策略(非必传)
   * 
   * 查看附件回显方法: 通过上传策略和业务表id查询文件信息
   */
  @Input() businessCode: string="";

  /**
   * 用来实现刷新的参数
   *
   */
  @Input() refresh: string = "";

  /**
   * 是否显示图标
   * @ignore 
   */
  isShow:boolean = false;
  
  /**
  * 附件信息列表
  * @ignore 
  */
  attachmentList:any=[]

  
  /**
   * @ignore
   */
  constructor(
    private http:SwHttpClientService,
    private injector: Injector,
    private applicationRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver
    ) { }

  /**
   * @ignore
   */
  ngOnInit() {
  }

  ngOnChanges(changes:SimpleChanges): void {
    // 当businessId业务id改变时，只要还存在，就重新查询附件列表
    if(this.businessId!="" && this.businessId!=null && this.businessId!=undefined){
      this.getShowList();
    }    
  }

  /**
   * @ignore
   * 根据业务id和策略标识进行回显的方法
   */
  getShowList(){
    let param = {};
    if(this.businessCode!=""){
      // 如果策略存在，就根据策略和业务id查询
      param = {objectId:this.businessId,code:this.businessCode}
    }else{
      // 如果策略不存在，就根据业务id查询
      param = {objectId:this.businessId}
    }
    this.http.Post(environment.fileWebAPI+"refFileObject/queryList",param).subscribe(data=>{
      if(data && data["code"] == 200){
        // 查询结果又数据，就显示附件图标，没有数据，就将附件图标隐藏
        this.isShow = data["data"]["records"].length != 0
        this.attachmentList = data["data"]["records"]
      }
    })
  }


  SwCheckAttachmentBoxComponentRef:any;

  /**
   * @ignore
   * 点击附件图标弹出模态框，显示文件列表
   */
  openAttachment(){
    
    let com
    let param = {};
    // 再次查询文件信息
    if(this.businessCode!=""){
      param = {objectId:this.businessId,code:this.businessCode}
    }else{
      param = {objectId:this.businessId}
    }
    this.http.Post(environment.fileWebAPI+"refFileObject/queryList",param).subscribe(data=>{
      if(data["code"] == 200){
        if(data["data"]["records"] !=null){
          if(data["data"]["records"].length>0){
            // 查询结果又数据，就显示附件图标，没有数据，就将附件图标隐藏
            this.isShow = true;
            this.attachmentList = data["data"]["records"]
            com = document.createElement(SwCheckAttachmentBoxComponent.name);
            //创建动态组件
            const factory = this.componentFactoryResolver.resolveComponentFactory(SwCheckAttachmentBoxComponent);
            this.SwCheckAttachmentBoxComponentRef = factory.create(this.injector, [], com);
            this.applicationRef.attachView(this.SwCheckAttachmentBoxComponentRef.hostView);
            // 向组件传递参数
            this.SwCheckAttachmentBoxComponentRef.instance["attachmentList"] = this.attachmentList;
            // 向组件传递回调函数
            this.SwCheckAttachmentBoxComponentRef.instance["callback"].subscribe(data => {
              try {
                // 触发回调就销毁组件
                document.body.removeChild(com);
                this.applicationRef.detachView(this.SwCheckAttachmentBoxComponentRef.hostView);
                this.SwCheckAttachmentBoxComponentRef.destroy()
              } catch (e) { }
            });
            // 将动态创建的组件加到dom中去
            document.body.appendChild(com);
          } else if(data["data"]["records"].length==0){
            this.isShow = false
          }
        }
      }
    })
  }


}
